<template>
    <div class="navigator">
        <div class="w-100 d-flex justify-content-between">

            <h2 class="mr-auto">Invoices</h2>

            <div class="d-flex align-items-center">
                <i class="ico ico-calendar fs-large dark mr-3"></i>
                <date-picker-new
                    class="dateRangePicker"
                    v-model="getInvoicePageFilters.dateRange"
                    :range="true"
                    :clearOutside="true"
                    :showFromTo="false"
                    @input="dateRangeChanged">
                </date-picker-new>
            </div>

        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DatePickerNew from 'vue-date'
import extendedVSelect from '@/extends/vue-select'

export default {
    data: function () {
        return {
        }
    },
    created: function() {
        this.setDefaultDateRange()
    },
    computed: {
        ...mapGetters([
            'getInvoicePageFilters'
        ])
    },
    methods: {
        ...mapActions([
            'downloadInvoiceList'
        ]),
        dateRangeChanged: function() {
            this.downloadInvoiceList()
        },
        setDefaultDateRange: function () {
            if(this.getInvoicePageFilters.dateRange[0] == "" || this.getInvoicePageFilters.dateRange.length < 2){
                this.$set(this.getInvoicePageFilters, 'dateRange', [
                    moment().format('YYYY-MM-DD'),
                    moment().format('YYYY-MM-DD')
                ])
            }
        }
    },
    components: {
        vSelect: extendedVSelect,
        DatePickerNew
    }
}
</script>

<style lang="scss" scoped>
.dateRangePicker{
    min-width: 250px;
}
</style>



// WEBPACK FOOTER //
// Navigator.vue?0e7d1658